import { request } from 'api/request';
import { PATCH, POST, PRODUCT_RESEARCH_API_URLS } from 'api/constants';

export default class Products {
  static getProducts(search) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.products.getProducts,
      search,
    });
  }

  static updateProduct(params, data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.products.updateProduct,
      method: PATCH,
      params,
      data,
    });
  }

  static bulkUpdateProduct(search, data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.products.bulkUpdateProduct,
      method: POST,
      search,
      data,
    });
  }

  static getProductPreview(search) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.products.previewProduct,
      search,
    });
  }

  static getTags() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.products.getTags,
    });
  }

  static getShopifyCollections() {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.products.getShopifyCollections,
    });
  }

  static bulkAddTags(search, data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.products.bulkAddTags,
      method: POST,
      search,
      data,
    });
  }

  static bulkRemoveTags(search, data) {
    return request({
      url: PRODUCT_RESEARCH_API_URLS.products.bulkRemoveTags,
      method: POST,
      search,
      data,
    });
  }
}
